export const ANNUAL_REPORT_API = `v1/annual-reports`;
export const IMAGE_API = `/v1/media/annual-reports`;
